import { BufferWhileExiting } from "@repo/ui/helpers/bufferWhileExiting";
import { ModalCloseButton } from "@repo/ui/Modal/modalCloseButton";
import { modalOverlay } from "@repo/ui/Modal/modalOverlay";
import type { FC } from "react";
import { Dialog, Header, Modal, ModalOverlay } from "react-aria-components";
import {
  AssessmentScoreFeedbackForm,
  type AssessmentFeedbackFormValues,
} from "./form.js";
import {
  renderInconsistentDecisionMessage,
  type InterviewDecisionWithScore,
} from "./helpers.js";

export interface AssessmentFeedbackDecisionModalProps {
  decision: InterviewDecisionWithScore | undefined;
  onRequestClose: () => void;
  onSubmit: (
    decision: InterviewDecisionWithScore,
    values: AssessmentFeedbackFormValues,
  ) => void;
}

/** Dismissible modal shown in bottom right to ask feedback when accepting/rejecting a low/high scoring interview. */
export const AssessmentFeedbackDecisionModal: FC<
  AssessmentFeedbackDecisionModalProps
> = (props) => {
  const { decision } = props;

  return (
    <ModalOverlay
      className={modalOverlay()}
      isDismissable
      isOpen={decision !== undefined}
      onOpenChange={(isOpen) => {
        if (!isOpen) {
          props.onRequestClose();
        }
      }}
    >
      <div className="absolute inset-0 z-10 flex flex-col items-end justify-end p-4">
        <Modal className="w-96 overflow-auto rounded-md bg-white shadow-lg ring-1 ring-black/5 data-[entering]:animate-popover-enter data-[exiting]:animate-popover-exit">
          {({ isExiting }) => (
            <BufferWhileExiting
              isOpen={decision !== undefined}
              isExiting={isExiting}
            >
              {decision ? (
                <Dialog className="space-y-2 p-4">
                  {({ close }) => (
                    <>
                      <div className="flex items-center justify-between">
                        <Header
                          slot="title"
                          className="text-lg font-semibold text-foreground"
                        >
                          Share your feedback
                        </Header>

                        <ModalCloseButton />
                      </div>

                      <p className="text-sm text-muted-foreground">
                        {renderInconsistentDecisionMessage(decision)}
                      </p>

                      <AssessmentScoreFeedbackForm
                        shouldAskForScore
                        onSubmit={(values) => {
                          props.onSubmit(decision, values);
                          close();
                        }}
                      />
                    </>
                  )}
                </Dialog>
              ) : null}
            </BufferWhileExiting>
          )}
        </Modal>
      </div>
    </ModalOverlay>
  );
};
